import './ui/ui';
import './utilities/input-formatter';
import './services/service-comparison';
import './utilities/hash-scroll';
import converter from './components/converter';
import './components/locale-switcher';
import mask from '@alpinejs/mask'
import Tool from './utilities/redirect';
import GTM from './services/gtm';
import './utilities/set-livewire-token';
import loanVerify from './components/loan-verify';
import './components/amount-range-slider/AmountRangeSlider';
import analytics from './services/analytics';
import contactsRequest from './components/contacts-request';
import initQRCode from './utilities/initQRCode.js';
import './widgets/site-rating';
import initLoanObserver from './services/loan-observer';
import { onLivewirePageExpired } from './utilities/livewire-hooks';

window.GTM = new GTM;

const loanVerifyGtmEventNames = new Set([
    'broker_start',
    'client_input',
    'loan_term',
    'info_input',
    'sms_otp_input',
]);

if (!window.__loanVerifyGtmBridgeInitialized) {
    window.__loanVerifyGtmBridgeInitialized = true;

    window.addEventListener('loan-verify-gtm-event', (event) => {
        const eventName = event?.detail?.eventName;
        if (!eventName || !loanVerifyGtmEventNames.has(eventName)) {
            return;
        }

        if (!window.GTM || typeof window.GTM.send !== 'function') {
            return;
        }

        const args = Array.isArray(event?.detail?.args) ? event.detail.args : [];
        window.GTM.send(eventName, ...args);
    });
}

const registerMainAlpine = () => {
    const Alpine = window.Alpine;

    if (!Alpine || window.__vsebankiMainAlpineRegistered) {
        return;
    }

    window.__vsebankiMainAlpineRegistered = true;

    Alpine.plugin(mask);
    Alpine.plugin(converter);
    Alpine.plugin(loanVerify);
    Alpine.plugin(contactsRequest);

    Alpine.data('Tool', Tool);
    Alpine.data('initQRCode', initQRCode);
};

if (window.Alpine) {
    registerMainAlpine();
} else {
    document.addEventListener('alpine:init', registerMainAlpine, { once: true });
}

analytics();
initLoanObserver();

onLivewirePageExpired(async () => {
    if (confirm('Срок действия этой страницы истек.\n' + 'Хотите обновить страницу?')) {
        try {
            await fetch("/regenerate-csrf");
        } catch (error) {
            console.error('Ошибка при обновлении CSRF токена:', error);
        }
        window.location.reload();
    }
});
